import { Box } from '@mui/material'
import { CarrierType, CheckType } from '@planning/app/api'
import { usePlanningStore } from '@planning/AppProvider'
import { TallymanV2ViewStore } from '@planning/rt-stores/tallyman'
import { observer } from 'mobx-react-lite'
import { FC, useEffect } from 'react'
import { RailSelectionStepper } from './Components/RailSelectionStepper'
import { VesselSelectionStepper, VesselVisitOperation } from './Components/VesselSelectionStepper'

interface IProps {
  store: TallymanV2ViewStore
  selectedCarrierType: CarrierType
  onSelectTrainOperation: (operation: CheckType) => void
  onSelectVesselOperation: (operation: VesselVisitOperation) => void
  onVesselSelection: (id: number) => void
  onCraneSelection: (id: number) => void
}

export const SelectCarrierAndOperation: FC<IProps> = observer(
  ({
    store,
    selectedCarrierType,
    onSelectVesselOperation,
    onSelectTrainOperation,
    onVesselSelection,
    onCraneSelection,
  }) => {
    const { tenantStore } = usePlanningStore()

    const skipRailTally = tenantStore.skipRailTally
    const skipVesselTally = tenantStore.skipVesselTally
    const skipRailTallyLoadPreparation = tenantStore.skipRailTallyLoadPreparation

    useEffect(() => {
      window.scrollTo(0, 0)
    }, [])

    if (!store.vesselTallyStore || !store.railTallyStore) return <></>

    return (
      <Box
        style={{
          minHeight: 'calc(100vh - 65px)',
        }}
      >
        {selectedCarrierType === CarrierType.Vessel && !skipVesselTally && (
          <VesselSelectionStepper
            store={store.vesselTallyStore}
            onSelectOperation={onSelectVesselOperation}
            onVesselSelection={onVesselSelection}
            onCraneSelection={onCraneSelection}
          />
        )}

        {selectedCarrierType === CarrierType.Train && !skipRailTally && (
          <RailSelectionStepper
            store={store.railTallyStore}
            skipRailTallyLoadPreparation={skipRailTallyLoadPreparation}
            onSelectTrainOperation={onSelectTrainOperation}
          />
        )}
      </Box>
    )
  },
)
